import { GenericTestRouteState } from './generic-test-state'

export const SummaryExecutiveTestRouteState = GenericTestRouteState.named(
  'SummaryExecutiveTestRouteState'
)
